import React from 'react';
import multiTenantTabs from './multi-tenant-tables/index';
import PropertyInformation from './tabs-components/PropertyInformation';
import CurrentRR from './tabs-components/CurrentRR';
import CurrentReimbursement from './tabs-components/CurrentReimbursement';
import Pricing from './tabs-components/Pricing';
import Expenses from './tabs-components/Expenses';
import Marketing from './tabs-components/Marketing';
import {buildGeneralInformationRow} from './multi-tenant-tables/current-rr-tab/general-information';
import {buildDetailedInformationRow} from './multi-tenant-tables/current-rr-tab/detailed-information';
import {buildDetailedInformationRowReimbursement} from './multi-tenant-tables/current-reimbursement-tab/detailed-information';
import {buildRentRollRow} from './multi-tenant-tables/marketing-tab/rent-roll';
import {buildReimbursementsRow} from "./multi-tenant-tables/marketing-tab/reimbursements";
import {buildReimbursementTypes, buildReimbursableOpEx} from './multi-tenant-tables/current-reimbursement-tab/annex';
import request from "arcdynamic-request";
import unitedStates from 'united-states';
import {dateProps, numberProps, stringProps, tenantFields, tenantTypeFields, defaultValues} from './mt-fields-to-save';
import BaseTabComponent from "./tabs-components/BaseTabComponent";
import {stringISOtoUS, stringUStoISO} from '../../date-converter';
import PrintMultiTenant from "../PrintMultiTenant";
import {addCommasToNumber, findTenantRow} from "../../utils";
import {UNDERWRITING_MULTI_TENANT, UNDERWRITING_PARCELS, UNDERWRITING_EXPENSES_CAMS, UNDERWRITING_TENANT_TYPES, UNDERWRITING_TENANTS, TENANTS} from '../../consts/tables';
import {UNDERWRITING_TENANT_LIST, } from '../../consts/queries';
import {executeQuery} from "../../requests/executeQuery";
import filter from "../../filter";

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');
const find = require('lodash.find');

export const reimbursementTypesNo = 15;
export const defaultReimbursementTypesNo = 7;
export const camDefaultRowNo = 5;
export const analysisDateIndex = 1;
export const expensesHeaderIndex = 2;
let taxAssessmentsNo = 4;

export default class UnderwritingMultiTenant extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                tabs: multiTenantTabs,
            },
            original: {
                tabs: multiTenantTabs,
            },
            selectedTab: 'marketing-tab',
            newData: null,
            parcelsData: null,
            camData: null,
            tenantsData: null,
            tenantTypeData: null,
            sqFtUpdated: false,
            camPSFSumUpdated: false,
            mgmtUpdated: false,
            insuranceUpdated: false,
            taxesUpdated: false,
            dataLoaded: false,
            isProformaVisible: false,
            isProformaVisiblePricing: false,
            isAdditionalPriceVisible: false,
            isMarketingAdditionalPriceVisible: false,
            displayPopupSubmit: false,
            sortState: 'default',
            movedRows: false,
        };
        this.getUnderwritingData = this.getUnderwritingData.bind(this);
        this.tabValueChange = this.tabValueChange.bind(this);
        this.tabValuesChange = this.tabValuesChange.bind(this);
        this.addRow = this.addRow.bind(this);
        this.deleteRowCurrentRR = this.deleteRowCurrentRR.bind(this);
        this.deleteRowCAM = this.deleteRowCAM.bind(this);
        this.moveRow = this.moveRow.bind(this);
        this.moveCorrespondingRows = this.moveCorrespondingRows.bind(this);
        this.reassignTenantRowIds = this.reassignTenantRowIds.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.findTenant = this.findTenant.bind(this);
        this.saveTenant = this.saveTenant.bind(this);
        this.handleExpand = this.handleExpand.bind(this);
        this.togglePopupMessage = this.togglePopupMessage.bind(this);
        this.setState = this.setState.bind(this);
        this.sortTenants = this.sortTenants.bind(this);
    }

    async componentDidMount() {
        await this.getUnderwritingData();
        this.setDefaultValues();
    }

    static findCamRowNO(rows) {
        let lastCamRowIndex = -1, camNo = 0;
        rows.map((row, index) => {
            if (/(cam-[0-9])/g.test(row[0])) {
                lastCamRowIndex = index;
                camNo++;
            }
        });
        return {lastCamRowIndex, camNo};
    }

    setForceStatic(newData, prop) {
        if (prop.hasOwnProperty('valueCellIndex')) {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].forceStatic = !prop.hasOwnProperty('forceStatic');
        } else {
            newData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].forceStatic = !prop.hasOwnProperty('forceStatic');
        }
    }

    setFieldsDisabled(data) {
        const newData = cloneDeep(data);

        stringProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        dateProps.map(prop => {
            this.setForceStatic(newData, prop);
        });
        numberProps.map(prop => {
            this.setForceStatic(newData, prop);
        });

        for (let index = 0; index < taxAssessmentsNo; index++) {
            newData.tabs['property-information-tab'].tables['parcel'].rows[`tax-assessment-${index+1}`].valueCells.map(cell => {
                cell.forceStatic = true;
            });
        }

        const camRows = newData.tabs['expenses-tab'].tables['expenses'].rows;
        const cams = Object.entries(camRows);
        let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(cams);
        for (let index = 0; index < camNo; index++) {
            camRows[`cam-${index+1}`].valueCells.map(cell => {
                if (cell.editable) {
                    cell.forceStatic = true;
                }
            });
        }

        const tenantNo = Object.keys(newData.tabs['current-rr-tab'].tables['general-information'].rows).length;
        tenantFields.map(prop => {
            for (let index = 0; index < tenantNo; index++) {
                newData.tabs[prop.tab].tables[prop.table].rows[index].valueCells[prop.valueCellIndex].forceStatic = true;
            }
        });

        const reimbursementTypes = newData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        for (let index = 0; index < reimbursementTypesNo; index++) {
            const row = reimbursementTypes[index];
            row.valueCells.map((cell, index) => {
                if (![0, 8, 10].includes(index)) {
                    cell.forceStatic = true;
                }
            });
        }

        return newData;
    }

    async getUnderwritingData(isSaved) {
        let data = cloneDeep(this.state.data);
        const propsData = this.props.data;

        // Set the dropdown values
        data.tabs['property-information-tab'].tables['general-information'].rows['state'].dropdownValues = unitedStates;

        if (!this.props.data.ARCIMEDES_ROW_ID) {
            await this.initTenants(data, [{}]);
            return;
        }

        await this.getTenants(data);

        const res = await Promise.all([
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_MULTI_TENANT, {
                    filter: [{
                        'text': this.props.data.ARCIMEDES_ROW_ID,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }],
                }],
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_PARCELS, {
                    filter: [{
                        'text': this.props.data.ARCIMEDES_ROW_ID,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }],
                    order: [{
                        code: 'PARCEL',
                        type: 'asc',
                    }]
                }],
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_EXPENSES_CAMS, {
                    filter: [{
                        'text': this.props.data.ARCIMEDES_ROW_ID,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }, {
                        'text': '',
                        'code': 'DELETED',
                        'type': 'null',
                    }],
                    filterType: 'and',
                    order: [{
                        code: 'CAM_INDEX',
                        type: 'asc',
                    }]
                }],
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.getData',
                params: ['code', UNDERWRITING_TENANT_TYPES, {
                    filter: [{
                        'text': this.props.data.ARCIMEDES_ROW_ID,
                        'code': 'PROPERTY_ID',
                        'type': 'exact',
                    }],
                    order: [{
                        code: 'REIMB_TYPES_INDEX',
                        type: 'asc',
                    }]
                }],
            })
        ]);

        if (res) {
            const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
            const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'];
            const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'];
            const tenantOpEx = data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'];
            const tenantOpExProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursable-op-ex'];
            let parcelsData = null;
            let camData = null;
            let tenantTypeData = null;

            // Manage data from PROPERTIES table
            stringProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] || '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] || '';
                    }
                }
            });

            dateProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = propsData[prop.key] ? stringISOtoUS(propsData[prop.key]) : '';
                    }
                }
            });

            numberProps.map(prop => {
                // get property props
                if (propsData.hasOwnProperty(prop.key)) {
                    let value;
                    if (prop.withReplace && prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')).toFixed(2) : '';
                    } else if (prop.withToFixed) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key]).toFixed(2) : '';
                    } else if (prop.withReplace) {
                        value = propsData[prop.key] ? parseFloat(propsData[prop.key].replace(/,/g, '')) : '';
                    } else {
                        value = parseFloat(propsData[prop.key]) || '';
                    }
                    if (prop.hasOwnProperty('valueCellIndex')) {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = value;
                    } else {
                        data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = value;
                    }
                }
            });

            // Manage data from UNDERWRITING_TENANT_TYPES table
            if (res[3] && res[3].success && Array.isArray(res[3].data)) {
                tenantTypeData = res[3].data.length > 0 ? cloneDeep(res[3].data) : Array(defaultReimbursementTypesNo).fill({});

                tenantOpEx.rows = buildReimbursableOpEx('current-reimbursement-tab');
                tenantOpExProForma.rows = buildReimbursableOpEx('proforma-reimbursement-tab');

                tenantTypes.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = tenantTypeData[index] ? tenantTypeData[index] : {};
                    return buildReimbursementTypes(typesDataRow, index, 'current-reimbursement-tab');
                }));
                tenantTypesProForma.rows = Object.assign({}, (new Array(reimbursementTypesNo)).fill(null).map((row, index) => {
                    const typesDataRow = tenantTypeData[index] ? tenantTypeData[index] : {};
                    return buildReimbursementTypes(typesDataRow, index, 'proforma-reimbursement-tab');
                }));
            }

            // Manage data from UNDERWRITING_EXPENSES_CAMS table
            if (res[2] && res[2].success && Array.isArray(res[2].data)) {
                camData = cloneDeep(res[2].data);
                const rows = Object.entries(data.tabs['expenses-tab'].tables['expenses'].rows);
                let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(rows);

                camData.map(row => {
                    if (camData.length > camNo) {
                        const dataWithRows = this.addRow(['expenses-tab', 'current-reimbursement-tab'], [['expenses'], ['reimbursable-op-ex']], 'cam-1', true, true);
                        data.tabs['expenses-tab'].tables['expenses'].rows = dataWithRows.tabs['expenses-tab'].tables['expenses'].rows;
                        data.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows = dataWithRows.tabs['current-reimbursement-tab'].tables['reimbursable-op-ex'].rows;
                        camNo = camNo + camDefaultRowNo;
                    }
                    data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[0].value = row.CAM_NAME || '';
                    data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[2].value = row.CAM_VALUE ? parseFloat(row.CAM_VALUE).toFixed(2) : '';
                    data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[5].value = row.PROFORMA_CAM_VALUE ? parseFloat(row.PROFORMA_CAM_VALUE).toFixed(2) : '';
                    data.tabs['expenses-tab'].tables['expenses'].rows[`cam-${row.CAM_INDEX}`].valueCells[7].value = row.ARCIMEDES_ROW_ID;
                });
            }

            // Manage data from UNDERWRITING_MULTI_TENANT table
            if (res[0] && res[0].success && Array.isArray(res[0].data)) {
                const result = res[0].data[0] ? res[0].data[0] : {};

                stringProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] || '';
                        }
                    }
                });

                dateProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = result[prop.key] ? stringISOtoUS(result[prop.key]) : '';
                        }
                    }
                });

                numberProps.map(prop => {
                    // get underwriting data
                    if (result.hasOwnProperty(prop.key)) {
                        if (prop.hasOwnProperty('valueCellIndex')) {
                            if (prop.withReplace && prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key].replace(/,/g, '')).toFixed(2) : '';
                                return;
                            }
                            if (prop.withToFixed) {
                                data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = result[prop.key] ? parseFloat(result[prop.key]).toFixed(2) : '';
                                return;
                            }
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value = parseFloat(result[prop.key]) || '';
                        } else {
                            data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value = parseFloat(result[prop.key]) || '';
                        }
                    }
                });
            }

            // Manage data from UNDERWRITING_PARCELS table
            if (res[1] && res[1].success && Array.isArray(res[1].data)) {
                parcelsData = cloneDeep(res[1].data);

                parcelsData.map((row, index) => {
                    parcels[`tax-assessment-${index + 1}`].valueCells[0].value = row.PARCEL || '';
                    parcels[`tax-assessment-${index + 1}`].valueCells[1].value = parseFloat(row.ASSESSED_VALUE) || '';
                    parcels[`tax-assessment-${index + 1}`].valueCells[2].value = parseFloat(row.TAX_LIABILITY) || '';
                });
            }

            this.setState({
                data: data,
                original: cloneDeep(data),
                parcelsData: parcelsData,
                camData: camData,
                tenantTypeData: tenantTypeData,
            }, () => {
                if (isSaved) this.props.parentSetData({success: 'Saved'});
            });
        }
    }

    async getTenants(data, key, sort, sortState) {
        const query = {
            PROPERTY_ID: this.props.data.ARCIMEDES_ROW_ID,
        };
        if (key && sort) query.order = `${key}.${sort}`;
        else query.order = 'TENANT_ROW_ID.asc';
        const options = filter(query, 'underwritingMT');
        const res = await executeQuery({queryName: UNDERWRITING_TENANT_LIST, options});

        let foundTenants = [{}];
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            const tenantsData = res.data;

            tenantsData.map((row, index) => {
                tenantFields.map(prop => {
                    if (!foundTenants[index]) {
                        foundTenants[index] = {};
                    }
                    switch (prop.type) {
                        case 'string': {
                            foundTenants[index][prop.key] = row[prop.key] || '';
                            break;
                        }
                        case 'number': {
                            let value;
                            if (prop.withReplace && prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key].replace(/,/g, '')).toFixed(2) : '';
                            } else if (prop.withToFixed) {
                                value = row[prop.key] ? parseFloat(row[prop.key]).toFixed(2) : '';
                            } else if (prop.withReplace) {
                                value = row[prop.key] ? parseFloat(row[prop.key].replace(/,/g, '')) : '';
                            } else {
                                value = parseFloat(row[prop.key]) || '';
                            }

                            foundTenants[index][prop.key] = value;
                            break;
                        }
                        case 'date': {
                            foundTenants[index][prop.key] = row[prop.key] ? stringISOtoUS(row[prop.key]) : '';
                            break;
                        }
                    }
                });
            });

            const state = {
                tenantsData: tenantsData,
            };
            if (sortState) state.sortState = sortState;

            this.setState(state);
        }

        await this.initTenants(data, foundTenants);
    }

    initTenants(data, tenants) {
        const generalInformation = data.tabs['current-rr-tab'].tables['general-information'];
        const detailedInformation = data.tabs['current-rr-tab'].tables['detailed-information'];
        const generalInformationProForma = data.tabs['proforma-rr-tab'].tables['general-information'];
        const detailedInformationProForma = data.tabs['proforma-rr-tab'].tables['detailed-information'];
        const proformaReimbursementDetailedInformation = data.tabs['proforma-reimbursement-tab'].tables['detailed-information'];
        const currentReimbursementDetailedInformation = data.tabs['current-reimbursement-tab'].tables['detailed-information'];
        const marketingRentRoll = data.tabs['marketing-tab'].tables['rent-roll'];
        const marketingReimbursements = data.tabs['marketing-tab'].tables['reimbursements'];

        generalInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'current-rr-tab');
        }));
        detailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'current-rr-tab');
        }));
        generalInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildGeneralInformationRow(row, 'proforma-rr-tab');
        }));
        detailedInformationProForma.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRow(row, 'proforma-rr-tab');
        }));
        proformaReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'proforma-reimbursement-tab');
        }));
        currentReimbursementDetailedInformation.rows = Object.assign({}, tenants.map((row) => {
            return buildDetailedInformationRowReimbursement(row, 'current-reimbursement-tab');
        }));
        marketingRentRoll.rows = Object.assign({}, tenants.map((row) => {
            return buildRentRollRow(row);
        }));
        marketingReimbursements.rows = Object.assign({}, tenants.map((row) => {
            return buildReimbursementsRow(row);
        }));

        this.setState({
            data: data,
            original: cloneDeep(data)
        });
    }

    setDefaultValue(tabs, field, rowIdentifier, precomputedValues) {
        const defaultValue = field.getDefaultValue({index: rowIdentifier, tabs, precomputedValues}) || '';
        const row = tabs[field.tab].tables[field.table].rows[rowIdentifier];
        if (field.hasOwnProperty('valueCellIndex') && row.valueCells[field.valueCellIndex].type === 'boolean' && row.valueCells[field.valueCellIndex].value === null) {
            row.valueCells[field.valueCellIndex].value = defaultValue;
            return;
        }
        if (field.hasOwnProperty('valueCellIndex') && row.valueCells[field.valueCellIndex].type !== 'boolean' && !row.valueCells[field.valueCellIndex].value) {
            row.valueCells[field.valueCellIndex].value = defaultValue;
            return;
        }
        if (!row.value) {
            row.value = defaultValue;
        }
    }

    setDefaultValues() {
        let data = cloneDeep(this.state.data);
        // Computing heavily-used values at the start of the render.
        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(data.tabs);

        defaultValues.map(field => {
            if (field.hasOwnProperty('tableKey')) {
                this.setDefaultValue(data.tabs, field, field.tableKey, precomputedValues);
            } else {
                if (field.tab === 'proforma-rr-tab') {
                    const tenantRowsNo = Object.keys(data.tabs[field.tab].tables['detailed-information'].rows).length;
                    for (let index = 0; index < tenantRowsNo; index++) {
                        this.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
                if (['current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(field.tab)) {
                    for (let index = 0; index < defaultReimbursementTypesNo; index++) {
                        this.setDefaultValue(data.tabs, field, index, precomputedValues);
                    }
                }
            }
        });

        this.setState({
            data: data,
            dataLoaded: true,
        });
    }

    togglePopupMessage() {
        this.setState({displayPopupSubmit: !this.state.displayPopupSubmit})
    }

    changeTab(tabKey) {
        const state = cloneDeep(this.state);
        state.selectedTab = tabKey;
        this.setState(state);
    }

    tabValueChange(tab, table, row, value, columnIndex, camChanged = null, mgmtChanged = null, insuranceChanged = null, taxesChanged = null) {
        const data = cloneDeep(this.state.data);
        if (columnIndex === undefined || columnIndex === null) {
            data.tabs[tab].tables[table].rows[row].value = value;
        } else {
            data.tabs[tab].tables[table].rows[row].valueCells[columnIndex].value = value;
        }

        const state = {
            data: data,
            sqFtUpdated: false,
        };
        if (camChanged !== null) state.camPSFSumUpdated = camChanged;
        if (mgmtChanged !== null) state.mgmtUpdated = mgmtChanged;
        if (insuranceChanged !== null) state.insuranceUpdated = insuranceChanged;
        if (taxesChanged !== null) state.taxesUpdated = taxesChanged;
        this.setState(state);
    }

    tabValuesChange({tabs, tables, rowIds, values, columnIds, sqFtChanged = null, camChanged = null, mgmtChanged = null, insuranceChanged = null, taxesChanged = null}) {
        const data = cloneDeep(this.state.data);
        tabs.forEach((tab, index) => {
            const table = tables[index];
            const rowIndex = rowIds[index];
            const columnIndex = columnIds[index];
            const value = values[index];
            if (columnIndex === undefined || columnIndex === null) {
                data.tabs[tab].tables[table].rows[rowIndex].value = value;
            } else {
                data.tabs[tab].tables[table].rows[rowIndex].valueCells[columnIndex].value = value;
            }
        });

        const state = {
            data: data,
        };
        if (sqFtChanged !== null) state.sqFtUpdated = sqFtChanged;
        if (camChanged !== null) state.camPSFSumUpdated = camChanged;
        if (mgmtChanged !== null) state.mgmtUpdated = mgmtChanged;
        if (insuranceChanged !== null) state.insuranceUpdated = insuranceChanged;
        if (taxesChanged !== null) state.taxesUpdated = taxesChanged;
        this.setState(state);
    }

    addRow(tabIdentifiers, tableIdentifiers, rowIdentifier, isCAMRow = false, withReturn = false) {
        let data = cloneDeep(this.state.data);
        let newRowIdentifier = Date.now().toString();

        // generate TABLE_ROW_ID
        let maxIndex = -1;
        if (tabIdentifiers.includes('current-rr-tab')) {
            const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
            const tableRowIdIndex = rows[0].valueCells.length - 1;  // TENANT_ROW_ID should always be the last column
            Object.keys(rows).forEach(key => {
                const value = parseInt(rows[key].valueCells[tableRowIdIndex].value);
                maxIndex =  value > maxIndex ? value : maxIndex;
            });

            // the keys have to be consecutive because of the drag & drop
            newRowIdentifier = Object.keys(rows).length;
        }

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                data.tabs[tabIdentifier] = this.addRowToTable(data.tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex);
            });
        });

        if (withReturn) return data;
        this.setState({data: data});
    }

    addRowToTable(tabs, tabIdentifier, tableIdentifier, rowIdentifier, newRowIdentifier, isCAMRow, maxIndex) {
        let rows = tabs[tabIdentifier].tables[tableIdentifier].rows;
        let auxRow = cloneDeep(rows[rowIdentifier]);
        const tableRowIdIndex = auxRow.valueCells.length - 1;  // TENANT_ROW_ID should always be the last column

        auxRow.valueCells.forEach((cell, index) => {
            if (['current-rr-tab', 'proforma-rr-tab', 'current-reimbursement-tab', 'proforma-reimbursement-tab'].includes(tabIdentifier) &&
                ['general-information', 'detailed-information'].includes(tableIdentifier) &&
                index === tableRowIdIndex) {
                cell.value = (maxIndex + 1).toString();
                return;
            }
            if ((cell.editable || cell.hidden) && cell.hasOwnProperty('value')) {
                cell.value = '';
            }
        });

        rows = Object.entries(rows);

        if (isCAMRow) {
            let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(rows);
            const defaultCamRowNo = 5;
            for (let index = 0; index < defaultCamRowNo; index++) {
                lastCamRowIndex++;
                rows.splice(lastCamRowIndex, 0, cloneDeep([`cam-${camNo + 1}`, auxRow]));
                camNo++;
            }
        } else {
            rows.push([newRowIdentifier, auxRow]);
        }

        const rowsObj = {};
        rows.map(item => {
            rowsObj[item[0]] = item[1];
        });

        tabs[tabIdentifier].tables[tableIdentifier].rows = rowsObj;

        return tabs[tabIdentifier];
    }

    deleteRowCurrentRR(rowIdentifier) {
        let data = cloneDeep(this.state.data);

        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['current-rr-tab'] = this.deleteRowFromTable(data.tabs['current-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'general-information', rowIdentifier, true);
        data.tabs['proforma-rr-tab'] = this.deleteRowFromTable(data.tabs['proforma-rr-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['current-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['current-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['proforma-reimbursement-tab'] = this.deleteRowFromTable(data.tabs['proforma-reimbursement-tab'], 'detailed-information', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'rent-roll', rowIdentifier, true);
        data.tabs['marketing-tab'] = this.deleteRowFromTable(data.tabs['marketing-tab'], 'reimbursements', rowIdentifier, true);

        this.setState({data});
    }

    deleteRowFromTable(tab, tableIdentifier, rowIdentifier, consecutive) {
        const rowsCount = Object.keys(tab.tables[tableIdentifier].rows).length;
        if (rowsCount <= 1) {
            alert("You can't delete all the rows from the table!");
            return null;
        }

        if (consecutive) {
            // move rows up and delete the last one
            const tenantRowIdIndex = tab.tables[tableIdentifier].rows[rowIdentifier].valueCells.length - 1;
            for (let index = parseInt(rowIdentifier); index < rowsCount - 1; index++) {
                const tenantRowId = tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value;
                tab.tables[tableIdentifier].rows[index] = cloneDeep(tab.tables[tableIdentifier].rows[index + 1]);
                tab.tables[tableIdentifier].rows[index].valueCells[tenantRowIdIndex].value = tenantRowId;
            }
            delete tab.tables[tableIdentifier].rows[rowsCount - 1];
        } else {
            delete tab.tables[tableIdentifier].rows[rowIdentifier];
        }

        return tab;
    }

    deleteRowCAM(tabIdentifiers, tableIdentifiers, rowIdentifier) {
        let data = cloneDeep(this.state.data);

        tabIdentifiers.forEach((tabIdentifier, index) => {
            tableIdentifiers[index].forEach(tableIdentifier => {
                const rows = data.tabs[tabIdentifier].tables[tableIdentifier].rows;
                const rowsAsArray = Object.entries(rows);
                let {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(rowsAsArray);

                if (camNo <= camDefaultRowNo) {
                    alert("You can't delete more rows from the table!");
                    return null;
                } else {
                    let camIndex = parseInt(rowIdentifier.split('-')[1], 10);
                    while (rows[`cam-${camIndex+1}`]) {
                        rows[`cam-${camIndex}`] = rows[`cam-${camIndex+1}`];
                        camIndex++;
                    }
                    delete rows[`cam-${camIndex}`];
                }
            });
        });

        this.setState({data: data});
    }

    moveRow({tabId, tableId, dragIndex, hoverIndex}) {
        const data = cloneDeep(this.state.data);
        const rows = data.tabs[tabId].tables[tableId].rows;
        const dragRow = cloneDeep(rows[dragIndex]);
        rows[dragIndex] = rows[hoverIndex];
        rows[hoverIndex] = dragRow;
        this.setState({
            data,
            movedRows: true,
        });
    }

    moveCorrespondingRows({changedTabId, changedTableId, tabIds, tableIds}) {
        // move all corresponding rows after dnd in Current Rent Roll general-information table & reset sort
        if (this.state.movedRows) {
            const data = cloneDeep(this.state.data);
            const changedRows = data.tabs[changedTabId].tables[changedTableId].rows;
            const valKeyIndex = changedRows[0].valueCells.length - 1;

            tabIds.map((tabId, index) => {
                tableIds[index].map(tableId => {
                    const keys = Object.keys(changedRows);
                    const rows = data.tabs[tabId].tables[tableId].rows;
                    const valueKeyIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
                    data.tabs[tabId].tables[tableId].rows = keys.reduce((obj, key) => ({...obj, [key]: findTenantRow(rows, valueKeyIndex, changedRows[key].valueCells[valKeyIndex].value)}), {});
                });
            });
            this.setState({
                data,
                sortState: 'default',
            });
        }
    }

    reassignTenantRowIds() {
        const data = cloneDeep(this.state.data);
        const rows = data.tabs['current-rr-tab'].tables['general-information'].rows;
        const tenantRowId = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
        const ids = [];

        Object.keys(rows).forEach(key => {
            ids.push(rows[key].valueCells[tenantRowId].value);
        });
        ids.sort();

        Object.keys(rows).map((key, index) => {
            rows[key].valueCells[tenantRowId].value = ids[index];
        });

        this.setState({
            data,
            movedRows: false,
        }, () => this.onSubmit());
    }

    findTenant(tenantName) {
        const tenants = this.props.allTenantsById;
        return find(tenants, {NAME: tenantName}) || null;
    }

    async saveTenant(tenantName) {
        const res = await request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.updateByTableCode',
            params: [TENANTS, {
                value: [{NAME: tenantName}],
            }],
        });
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            return res.data[0];
        }
    }

    async onSubmit() {
        const {data, parcelsData, camData, tenantsData, tenantTypeData} = this.state;
        const originalData = this.state.original;
        const propsData = cloneDeep(this.props.data);
        const propertyId = this.props.data.ARCIMEDES_ROW_ID;
        const underwritingData = {};

        stringProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                propsData[prop.key] = value;
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value;
                }
            }
        });

        dateProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                propsData[prop.key] = value;
            } else {
                // set underwritingData just if the value has been changed
                if (value !== originalValue) {
                    underwritingData[prop.key] = value ? stringUStoISO(value) : '';
                }
            }
        });

        numberProps.map(prop => {
            let value, originalValue;
            if (prop.hasOwnProperty('valueCellIndex')) {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].valueCells[prop.valueCellIndex].value;
            } else {
                value = data.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
                originalValue = originalData.tabs[prop.tab].tables[prop.table].rows[prop.tableKey].value;
            }

            if (prop.fromProps) {
                // set property props
                if (prop.withReplace) {
                    propsData[prop.key] = addCommasToNumber(value);
                    return;
                }
                propsData[prop.key] = value.toString();
            } else {
                if (value !== originalValue) {
                    underwritingData[prop.key] = parseFloat(value);
                }
            }
        });

        const precomputedValues = BaseTabComponent.precomputeHeavilyUsedValues(data.tabs);
        const noi = data.tabs['pricing-tab'].tables['net-operating-income'].rows['net-operating-income'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (noi > 0) {
            propsData.NET_OPERATING_INCOME = addCommasToNumber(noi);
        }
        const listPrice = data.tabs['pricing-tab'].tables['value'].rows['value'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (listPrice > 0) {
            propsData.LIST_PRICE = addCommasToNumber(listPrice);
        }
        const baseRent = data.tabs['pricing-tab'].tables['base-rent'].rows['occupied-space'].valueCells[2].getComputedValue(data.tabs, precomputedValues).internalValue;
        if (baseRent > 0) {
            propsData.BASE_RENT = addCommasToNumber(baseRent);
        }
        const sqft = data.tabs['marketing-tab'].tables['offering-summary'].rows['gross-leasable-area'].getComputedValue(data.tabs, '', precomputedValues).internalValue;
        if (sqft > 0 && !propsData.SQFT) {
            propsData.SQFT = addCommasToNumber(sqft);
        }
        propsData.VACANCY = data.tabs['current-rr-tab'].tables['sumed-detailed-information'].rows['first-row'].valueCells[0].getComputedValue(data.tabs, precomputedValues).internalValue;

        // set underwriting parcels cam just if the value has been changed
        const parcels = data.tabs['property-information-tab'].tables['parcel'].rows;
        const originalParcels = originalData.tabs['property-information-tab'].tables['parcel'].rows;
        const newParcelsData = [];
        const parcelCols = ['PARCEL', 'ASSESSED_VALUE', 'TAX_LIABILITY'];

        for (let index = 0; index < 4; index++) {
            const parcelObj = {};
            parcels[`tax-assessment-${index+1}`].valueCells.map((tax, taxIndex) => {
                if (tax.value !== originalParcels[`tax-assessment-${index+1}`].valueCells[taxIndex].value) {
                    parcelObj[parcelCols[taxIndex]] = tax.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(parcelObj).length && propertyId) {
                parcelObj.PROPERTY_ID = propertyId;
                if (parcelsData[index] && parcelsData[index].ARCIMEDES_ROW_ID) {
                    parcelObj.ARCIMEDES_ROW_ID = parcelsData[index].ARCIMEDES_ROW_ID;
                }
                newParcelsData.push(parcelObj);
            }
        }

        // set underwriting expenses cam just if the value has been changed
        const cams = data.tabs['expenses-tab'].tables['expenses'].rows;
        const originalCam = originalData.tabs['expenses-tab'].tables['expenses'].rows;
        const newCamData = [];
        const camCols = ['CAM_NAME', '', 'CAM_VALUE', '', '', 'PROFORMA_CAM_VALUE', ''];
        const camRows = Object.entries(cams);
        const {lastCamRowIndex, camNo} = UnderwritingMultiTenant.findCamRowNO(camRows);
        const deletedRows = camData ? cloneDeep(camData) : [];
        const arcRowIdIndex = cams['cam-1'].valueCells.length - 1;

        for (let index = 0; index < camNo; index++) {
            const camObj = {};
            const camKey = `cam-${index+1}`;
            const rowId = cams[camKey].valueCells[arcRowIdIndex].value;

            // remove existing rows in order to have only the deleted ones
            if (rowId) {
                const index = findIndex(deletedRows, {ARCIMEDES_ROW_ID: rowId});
                if (index > -1)
                    deletedRows.splice(index, 1);
            }

            const lastIndex = cams[camKey].valueCells.length - 2;
            cams[camKey].valueCells.map((cam, camIndex) => {
                if (camIndex < lastIndex &&
                    (!originalCam[camKey] && cam.editable ||
                     originalCam[camKey] && cam.value !== originalCam[camKey].valueCells[camIndex].value)) {
                    camObj[camCols[camIndex]] = cam.value;
                }
            });

            // Set only if there was at least a change and the property exists
            if (Object.keys(camObj).length && propertyId) {
                camObj.PROPERTY_ID = propertyId;
                camObj.CAM_INDEX = index + 1;
                if (rowId)
                    camObj.ARCIMEDES_ROW_ID = rowId;
                newCamData.push(camObj);
            }
        }

        deletedRows.map(row => {
            newCamData.push({
                ARCIMEDES_ROW_ID: row.ARCIMEDES_ROW_ID,
                DELETED: 1,
            });
        });

        // set underwriting current rr & current reimbursement just if the value has been changed
        let newTenantsData = [];
        let savedTenants = false;
        const newTenants = [];
        let tenantData = null;
        let deletedTenants = tenantsData ? cloneDeep(tenantsData) : [];

        await Promise.all(tenantFields.map(async prop => {
            const rows = data.tabs[prop.tab].tables[prop.table].rows;
            const originalRows = originalData.tabs[prop.tab].tables[prop.table].rows;
            const tenantRowIdIndex = rows[0].valueCells.length - 1; // TENANT_ROW_ID should always be the last column
            const arcRowIdIndex = tenantRowIdIndex - 1; // ARCIMEDES_ROW_ID should always be the last but one column

            await Promise.all(Object.keys(rows).map(async key => {
                if (prop.hasOwnProperty('valueCellIndex')) {
                    const arcRowId = rows[key].valueCells[arcRowIdIndex].value;
                    const tenantRowId = rows[key].valueCells[tenantRowIdIndex].value;
                    const value = rows[key].valueCells[prop.valueCellIndex].value;
                    const originalRow = findTenantRow(originalRows, arcRowIdIndex, arcRowId);
                    const originalValue = originalRow ? originalRow.valueCells[prop.valueCellIndex].value : '';

                    if (prop.key === 'ARCIMEDES_ROW_ID' && value) {
                        let tenantId = findIndex(deletedTenants, {ARCIMEDES_ROW_ID: value});
                        if (tenantId >= 0)
                            deletedTenants.splice(tenantId, 1);
                    }

                    // set only if there was a change
                    if (value !== originalValue && !['ARCIMEDES_ROW_ID', 'TENANT_ROW_ID'].includes(prop.key)) {
                        if (!newTenantsData[tenantRowId])
                            newTenantsData[tenantRowId] = {};

                        if (!newTenantsData[tenantRowId].PROPERTY_ID) {
                            newTenantsData[tenantRowId].PROPERTY_ID = propertyId ? propertyId : this.props.newPropertyId;
                            newTenantsData[tenantRowId].DELETED = null;
                            newTenantsData[tenantRowId].TENANT_ROW_ID = tenantRowId;
                            if (arcRowId)
                                newTenantsData[tenantRowId].ARCIMEDES_ROW_ID = arcRowId;
                        }

                        if (prop.key === 'TENANT_NAME') {
                            tenantData = find(tenantsData, {ARCIMEDES_ROW_ID: arcRowId});
                            if (tenantData)
                                deletedTenants.push({TENANT_ID: tenantData.TENANT_ID});

                            // find tenant by name in existing tenants
                            const tenant = this.findTenant(value);
                            // if it doesn't exist, first save Tenant in TENANTS table
                            if (!tenant) {
                                const newTenant = await this.saveTenant(value);
                                newTenants.push({ARCIMEDES_ROW_ID: newTenant.ARCIMEDES_ROW_ID, NAME: value});
                                newTenantsData[tenantRowId].TENANT_ID = newTenant.ARCIMEDES_ROW_ID;
                                propsData.TENANT_ID = propsData.TENANT_ID ? `${propsData.TENANT_ID},${newTenant.ARCIMEDES_ROW_ID}` : newTenant.ARCIMEDES_ROW_ID;
                                savedTenants = true;
                            } else {
                                newTenantsData[tenantRowId].TENANT_ID = tenant.ARCIMEDES_ROW_ID;
                                propsData.TENANT_ID = propsData.TENANT_ID ? `${propsData.TENANT_ID},${tenant.ARCIMEDES_ROW_ID}` : tenant.ARCIMEDES_ROW_ID;
                                savedTenants = true;
                            }
                        }

                        switch (prop.type) {
                            case 'string': {
                                newTenantsData[tenantRowId][prop.key] = value;
                                break;
                            }
                            case 'number': {
                                newTenantsData[tenantRowId][prop.key] = value ? parseFloat(value) : null;
                                break;
                            }
                            case 'date': {
                                newTenantsData[tenantRowId][prop.key] = value ? stringUStoISO(value) : null;
                                break;
                            }
                        }
                    }
                }
            }));
        }));

        newTenantsData = newTenantsData.filter(el => el);
        deletedTenants = deletedTenants.map(el => {
            if (propsData.TENANT_ID) {
                let ids = propsData.TENANT_ID.split(',');
                const index = ids.indexOf(el.TENANT_ID);
                if (index === -1) return;
                ids.splice(index, 1);
                ids = ids.join(',');
                // if TENANT_NAME was changed (new Tenant on existing row) delete it just from Property TENANT_ID
                if (el.TENANT_ID && !el.PROPERTY_ID) {
                    propsData.TENANT_ID = ids;
                    return el;
                }
                // if a tenant data (row) was deleted
                if (findIndex(newTenantsData, {ARCIMEDES_ROW_ID: el.ARCIMEDES_ROW_ID}) === -1) {
                    propsData.TENANT_ID = ids;
                    el.DELETED = '1';
                    newTenantsData.push(el);
                    return el;
                }
            }
        });

        // set underwriting current & pro forma reimbursement types just if the value has been changed
        const tenantTypes = data.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypes = originalData.tabs['current-reimbursement-tab'].tables['reimbursement-types'].rows;
        const tenantTypesProForma = data.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const originalTenantTypesProForma = originalData.tabs['proforma-reimbursement-tab'].tables['reimbursement-types'].rows;
        const newTenantTypesData = [];

        Object.keys(tenantTypes).map(key => {
            const tenantTypeObj = {};

            tenantTypeFields.map(prop => {
                let value = null;
                let originalValue = null;
                if (prop.key.includes('PRO_FORMA')) {
                    value = tenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypesProForma[key].valueCells[prop.valueCellIndex].value;
                } else {
                    value = tenantTypes[key].valueCells[prop.valueCellIndex].value;
                    originalValue = originalTenantTypes[key].valueCells[prop.valueCellIndex].value;
                }

                if (value !== originalValue) {
                    switch (prop.type) {
                        case 'string':
                            tenantTypeObj[prop.key] = value;
                            break;
                        case 'number':
                            tenantTypeObj[prop.key] = value && !isNaN(value) ? parseFloat(value) : null;
                            break;
                        case 'checkbox':
                            tenantTypeObj[prop.key] = value ? 1 : 0;
                            break;
                    }
                }
            });

            if (Object.keys(tenantTypeObj).length && propertyId) {
                if (!tenantTypeObj.PROPERTY_ID)
                    tenantTypeObj.PROPERTY_ID = propertyId;
                if (!tenantTypeObj.REIMB_TYPES_INDEX)
                    tenantTypeObj.REIMB_TYPES_INDEX = parseInt(key);
                if (tenantTypeData && tenantTypeData[key] && tenantTypeData[key].ARCIMEDES_ROW_ID)
                    tenantTypeObj.ARCIMEDES_ROW_ID = tenantTypeData[key].ARCIMEDES_ROW_ID;
                newTenantTypesData.push(tenantTypeObj);
            }
        });

        const id = propertyId ? propertyId : this.props.newPropertyId;
        if (Object.keys(underwritingData).length)
            underwritingData.PROPERTY_ID = id;
        if (!propertyId)
            propsData.ARCIMEDES_ROW_ID = this.props.newPropertyId;

        const noChangesDetected = !Object.keys(underwritingData).length && newParcelsData.length < 1 && newCamData.length < 1 && newTenantsData.length < 1 && newTenantTypesData.length < 1;
        const success = noChangesDetected ? 'No data to update' : '';

        // Sent back the property props
        this.setState({newData: propsData});
        this.props.parentSetData({newData: propsData, savedTenants: savedTenants, newTenants: newTenants, success});

        // No changes detected for Underwriting, nothing to do
        if (noChangesDetected) return;

        Promise.all([
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_MULTI_TENANT, {
                    value: [underwritingData],
                }]
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_PARCELS, {
                    value: newParcelsData,
                }]
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_EXPENSES_CAMS, {
                    value: newCamData,
                }]
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_TENANTS, {
                    value: newTenantsData,
                }]
            }),
            request(arc.path.api, {
                service: 'arcimedes',
                action: 'open.datasource.table.Data.updateByTableCode',
                params: [UNDERWRITING_TENANT_TYPES, {
                    value: newTenantTypesData,
                }]
            }),
        ]).then(res => {
            if (!res || !res[0] || (!res[0].success && Object.keys(underwritingData).length) ||
                !res[1] || (!res[1].success && newParcelsData.length) ||
                !res[2] || (!res[2].success && newCamData.length) ||
                !res[3] || (!res[3].success && newTenantsData.length) ||
                !res[4] || (!res[4].success && newTenantTypesData.length)) {
                this.props.parentSetData({error: 'Unidentified Error'});
                return;
            }

            this.getUnderwritingData(true);
        });
    }

    handleExpand({tabId, tablesId, rowsId, cellsId}) {
        let data = cloneDeep(this.state.data);
        const tables = data.tabs[tabId].tables;

        tablesId.map(tableId => {
            const rows = tables[tableId].rows ? tables[tableId].rows : {};
            const rId = rowsId && rowsId[tableId] ? rowsId[tableId] : Object.keys(rows);
            rId.map(rowId => {
                const cId = cellsId ? cellsId : Object.keys(rows[rowId].valueCells);
                cId.map(cellId => {
                    rows[rowId].valueCells[cellId].hidden = !rows[rowId].valueCells[cellId].hidden;
                });
            });

            const footerRow = tables[tableId].footerRow ? tables[tableId].footerRow : {};
            if (Object.keys(footerRow).length && cellsId) {
                cellsId.map(cellId => {
                    footerRow.valueCells[cellId].hidden = !footerRow.valueCells[cellId].hidden;
                });
            }
        });

        this.setState({data});
    }

    sortTenants(key, sort, sortState) {
        let data = cloneDeep(this.state.data);
        this.getTenants(data, key, sort, sortState);
    }

    render() {
        const {data, selectedTab, sqFtUpdated, camPSFSumUpdated, mgmtUpdated, insuranceUpdated, taxesUpdated, dataLoaded, movedRows} = this.state;
        const propertyImage = this.props.data.PHOTOS ? this.props.data.PHOTOS.split(',')[0] : '';
        const agents = this.props.agents;
        const disabled = !(this.props.isSuper || this.props.agentIsCurrentUser && ['Proposal', 'Property Info', 'Off Market', 'Removed'].includes(this.props.data.STATUS));
        const propertyMapProps = {
            LATITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LATITUDE) : 0,
            LONGITUDE: this.props.data.LATITUDE ? parseFloat(this.props.data.LONGITUDE) : 0,
            NAME: this.props.data.NAME
        };

        return (
            <div>
                <PrintMultiTenant location={this.props.location} tabs={data.tabs} propertyImage={propertyImage} propertyMapProps={propertyMapProps} agents={agents}/>
                <div className="Financials_content multi_tenant_content">
                    <div onMouseEnter={this.togglePopupMessage} onMouseLeave={this.togglePopupMessage} className='placeholder-button'/>
                    <button className={`Financials_submit_button${disabled ? '_disabled' : ''}`} onClick={movedRows ? this.reassignTenantRowIds : this.onSubmit} disabled={disabled}>Submit</button>
                    {disabled && this.state.displayPopupSubmit ? <div className='Financials_submit_message'>Don't have permission to save.</div> : null}
                    <div className="multi_tenant_tabs">
                        {Object.keys(data.tabs).map((tabKey) => {
                            const tab = data.tabs[tabKey];
                            return (
                                <div className={`tab ${selectedTab}${selectedTab === tabKey ? ' selected' : ''}${dataLoaded ? '' : ' disabled'}`} key={tabKey} onClick={() => {this.changeTab(tabKey)}}>
                                    {tab.name}
                                </div>
                            )
                        })}
                    </div>
                    <div className="content">
                        {selectedTab === 'marketing-tab' ?
                            <Marketing tabs={data.tabs} valueChange={this.tabValueChange} setState={this.setState} handleExpand={this.handleExpand}
                                       isMarketingAdditionalPriceVisible={this.state.isMarketingAdditionalPriceVisible}/>
                            : selectedTab === 'property-information-tab' ?
                                <PropertyInformation tabs={data.tabs} valueChange={this.tabValueChange}/>
                                : selectedTab === 'pricing-tab' ?
                                    <Pricing tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange} handleExpand={this.handleExpand}
                                             setState={this.setState} isProformaVisiblePricing={this.state.isProformaVisiblePricing} isAdditionalPriceVisible={this.state.isAdditionalPriceVisible}/>
                                    : selectedTab === 'current-rr-tab' ?
                                        <CurrentRR tabs={data.tabs} tab='current-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                   addRow={this.addRow} deleteRow={this.deleteRowCurrentRR} moveRow={this.moveRow} moveCorrespondingRows={this.moveCorrespondingRows}
                                                   sortState={this.state.sortState} sortTenants={this.sortTenants}/>
                                        : selectedTab === 'current-reimbursement-tab' ?
                                            <CurrentReimbursement tabs={data.tabs} tab='current-reimbursement-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                                  sqFtUpdated={sqFtUpdated} camPSFSumUpdated={camPSFSumUpdated} mgmtUpdated={mgmtUpdated} insuranceUpdated={insuranceUpdated} taxesUpdated={taxesUpdated}/>
                                            : selectedTab === 'expenses-tab' ?
                                                <Expenses tabs={data.tabs} valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                          addRow={this.addRow} deleteRow={this.deleteRowCAM}
                                                          handleExpand={this.handleExpand} setState={this.setState}
                                                          isProformaVisible={this.state.isProformaVisible}/>
                                                : selectedTab === 'proforma-rr-tab' ?
                                                    <CurrentRR tabs={data.tabs} tab='proforma-rr-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                               addRow={this.addRow} deleteRow={this.deleteRowCurrentRR}/>
                                                    : selectedTab === 'proforma-reimbursement-tab' ?
                                                        <CurrentReimbursement tabs={data.tabs} tab='proforma-reimbursement-tab' valueChange={this.tabValueChange} valuesChange={this.tabValuesChange}
                                                                              camPSFSumUpdated={camPSFSumUpdated} mgmtUpdated={mgmtUpdated} insuranceUpdated={insuranceUpdated} taxesUpdated={taxesUpdated}/>
                                                        : null
                        }
                    </div>
                </div>
            </div>
        )
    }
}